import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Popover } from "antd";
import { CloseOutlined, RightOutlined } from "@ant-design/icons";
import { getTruncateLectureWithWidth } from "Pages/MyScheduleBeta/utils/unmarkedLectureHelper";
import "./index.css";
export interface MobileCollapsedLecturesCardProps {
  event: any;
  gridStartHour?: number;
  hourHeight?: number;
  left?: string | number;
  right?: string | number;
  width?: string | number;
}

const formatTime = (dateStr: string) => {
  const d = new Date(dateStr);
  let h = d.getHours();
  const m = String(d.getMinutes()).padStart(2, "0");
  const ampm = h >= 12 ? "pm" : "am";
  h = h % 12;
  if (h === 0) h = 12;
  return `${h}:${m} ${ampm}`;
};

const MobileCollapsedLecturesCard: React.FC<
  MobileCollapsedLecturesCardProps
> = ({ event, gridStartHour = 7, hourHeight = 80, left, right, width }) => {
  const navigate = useNavigate();
  const [popoverOpen, setPopoverOpen] = useState(false);

  const start = new Date(event.startTime);
  const end = new Date(event.endTime);

  const startHour = start.getHours();
  const startMin = start.getMinutes();

  // compute duration in minutes
  const durationMins = (end.getTime() - start.getTime()) / (1000 * 60);

  // Math for positioning
  const topOffset = (startHour - gridStartHour + startMin / 60) * hourHeight;
  const height = (durationMins / 60) * hourHeight;

  const handleHiddenClick = (ev: any) => {
    setPopoverOpen(false);
    navigate(`/admin/schedule-beta/lecture-details/${ev.batchTimeTableId}`, {
      state: { lecture: ev, selectedSchedule: ev, event: ev },
    });
  };
  console.log("batchName:====", event.batchName.split("-"));
  const BATCHNAME_ARRAY = event.batchName.split("-");
  // const lectWidth = Math.floor(event.width);
  const popoverContent = (
    <div>
      <div
        style={{
          padding: "12px 16px",
          borderBottom: "1px solid #f0f0f0",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          style={{
            backgroundColor: "#e1f5fe",
            color: "#0288d1",
            padding: "4px 12px",
            borderRadius: "16px",
            fontSize: "12px",
            fontWeight: 600,
            textTransform: "uppercase",
          }}
        >
          {event.collapsedEvents?.length || 0} SESSIONS
        </div>
        <CloseOutlined
          style={{ cursor: "pointer", color: "#757575" }}
          onClick={(e) => {
            e.stopPropagation();
            setPopoverOpen(false);
          }}
        />
      </div>
      <div style={{ padding: "8px 0", maxHeight: "350px", overflowY: "auto" }}>
        <div
          style={{
            padding: "8px 16px",
            color: "#5f6368",
            fontSize: "14px",
            fontWeight: 500,
          }}
        >
          {new Date(event.startTime).toLocaleDateString("en-GB", {
            weekday: "short",
            day: "numeric",
            month: "short",
          })}
        </div>
        {event.collapsedEvents?.map((ev: any) => (
          <div
            key={ev.batchTimeTableId}
            style={{
              padding: "12px 16px",
              borderBottom: "1px solid #f0f0f0",
              cursor: "pointer",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            onClick={(e) => {
              e.stopPropagation();
              handleHiddenClick(ev);
            }}
          >
            <div>
              <div
                style={{
                  fontWeight: 600,
                  fontSize: "14px",
                  color: "#212121",
                }}
              >
                {getTruncateLectureWithWidth(ev.eventName, 33)}
              </div>
              <div
                style={{
                  fontSize: "10px",
                  color: "#5f6368",
                }}
              >
                {ev.batchName}
              </div>
              <div
                style={{
                  fontSize: "12px",
                  color: "#5f6368",
                  marginTop: "4px",
                }}
              >
                {formatTime(ev.startTime)} · {ev.room || "Room"}
              </div>
            </div>
            <RightOutlined style={{ color: "#bdbdbd" }} />
          </div>
        ))}
      </div>
    </div>
  );
  const visibleEvents = event.collapsedEvents.slice(0, 2);
  const remainingCount = event.collapsedEvents.length - 2;
  return (
    <Popover
      content={popoverContent}
      trigger="click"
      open={popoverOpen}
      onOpenChange={setPopoverOpen}
      placement="bottom"
      getPopupContainer={() => document.body}
      overlayClassName="custom-lecture-popover-mb"
      overlayInnerStyle={{
        padding: 0,
        borderRadius: "12px",
        overflow: "hidden",
      }}
      className="custom-lecture-popover-mb"
    >
      <div
        style={{
          position: "absolute",
          top: `${topOffset}px`,
          height: `${height}px`,
          left:
            left !== undefined
              ? typeof left === "number"
                ? `${left}px`
                : left
              : "8px",
          right:
            width !== undefined
              ? undefined
              : right !== undefined
              ? typeof right === "number"
                ? `${right}px`
                : right
              : "16px",
          width: "100%",
          backgroundColor: "#f1f3f4",
          border: "1px solid #dadce0",
          borderLeft: "4px solid #1a73e8",
          borderRadius: "8px",
          padding: "4px 0 4px 2px",
          cursor: "pointer",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
        }}
        onClick={(e) => {
          e.stopPropagation();
          setPopoverOpen(true);
        }}
      >
        <div>
          {visibleEvents.map((ev: any, index: number) => (
            <div
              key={index}
              style={{
                marginBottom: 6,
                lineHeight: 1.2,
              }}
            >
              <div
                style={{
                  color: "#1464F4",
                  fontWeight: 600,
                  fontSize: 10,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {getTruncateLectureWithWidth(ev.eventName, 33)}
              </div>
              <div
                style={{
                  color: "#98A2B3",
                  fontSize: 8,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {BATCHNAME_ARRAY?.[1]}
              </div>
            </div>
          ))}
        </div>

        {remainingCount > 0 && (
          <div
            style={{
              alignSelf: "flex-start",
              background: "#EEF4FF",
              color: "#1464F4",
              borderRadius: 20,
              padding: "2px 8px",
              fontSize: 10,
              fontWeight: 600,
            }}
          >
            +{remainingCount}
          </div>
        )}
        <div style={{ fontSize: "14px", fontWeight: 600, color: "#1a73e8" }}>
          <div style={{ display: "flex", flexWrap: "wrap", fontSize: "8px" }}>
            {/* {event.collapsedEvents.map((ev: any, index: number) => (
              <div key={index}>
                <div>{getTruncateLectureWithWidth(ev.eventName, 33)}</div>
                <div style={{ fontSize: "5px" }}>{BATCHNAME_ARRAY?.[1]}</div>
              </div>
            ))} */}
          </div>
        </div>
      </div>
    </Popover>
  );
};

export default MobileCollapsedLecturesCard;
